import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  totalPages: 0,
  totalDocs: 0,
  currentPage: 0,
  error: "",
  message: "",
};

export const getAllOffersAction = createAsyncThunk(
  "get-all-offers",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, search, partner_id } = data;
      const res = await axios.get(
        `/admins/api/getAllOffers?page=${page}&limit=${pageSize}&search=${search || ""}&partner_id=${partner_id || ""}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllOffersSlice = createSlice({
  name: "get-all-offers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllOffersAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllOffersAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
      state.totalPages = action?.payload?.totalPages;
      state.totalDocs = action?.payload?.totalDocs;
      state.currentPage = action?.payload?.currentPage;
    });
    builder.addCase(getAllOffersAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const getAllOffersReducer = getAllOffersSlice.reducer;
